import { render, staticRenderFns } from "./importDialog.vue?vue&type=template&id=bedf8de4&scoped=true"
import script from "./importDialog.vue?vue&type=script&lang=js"
export * from "./importDialog.vue?vue&type=script&lang=js"
import style0 from "./importDialog.vue?vue&type=style&index=0&id=bedf8de4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bedf8de4",
  null
  
)

export default component.exports